/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// Polyfill `process.env` for browser — required by @ag-ui/client backward compat middleware
if (typeof globalThis.process === 'undefined') {
  ;(globalThis as Record<string, unknown>).process = { env: {} }
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import PostHogProviderWrapper from './contexts/PostHogProviderWrapper'
import { silenceResizeObserverLoopError } from './lib/silenceResizeObserverLoopError'

silenceResizeObserverLoopError()

const elem = document.getElementById('root')!
const app = (
  <StrictMode>
    <PostHogProviderWrapper>
      <App />
    </PostHogProviderWrapper>
  </StrictMode>
)

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem))
  root.render(app)
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app)
}
